<ng-container >
<div class="btn-container">
    <button type="button" [ngClass]="
            props.isSubmit
            
                    ? props.type === 'light'
                    ? 'btn btn-light btn-sm mx-2 submit-btn'
                    : props.type === 'dark'
                    ? 'btn btn-dark btn-sm mx-2 submit-btn rounded'
                    : props.type === 'customBtn'
                    ? 'btn btn-sm btn-dark btnregister rounded  '
                    : props.type ==='primary'
                    ? 'btn btn-primary btn-block mt-5'
                    : 'btn btn-dark px-5 rounded'
                : props.isError
                ? props.type === 'primary'
                    
                    ? 'btn btn-info btn-sm mx-2 error-btn'
                    : props.type === 'light'
                    ? 'btn btn-light btn-sm mx-2 error-btn'
                    : props.type === 'dark'
                    ? 'btn btn-dark  btn-sm mx-2 error-btn rounded'
                   
                    : ''
               
               
                : props.type === 'light'
                ? 'btn btn-light btn-sm mx-2'
                : props.type === 'dark'
                ? ''
                
                : ''
        " (click)="onBtnClick($event)" [disabled]="valid" [ngStyle]="{ 'pointer-events': valid ? 'none' : '' }"
       >
        {{ props.label }}
    </button>
</div>

</ng-container>